/**
 * Stable CSS class names for E2E — Order filter drawer form.
 */
export const OOF = {
    form: 'order-filter-drawer__form',
    headerRoot: 'order-filter-drawer__header',
    headerTitle: 'order-filter-drawer__header-title',
    headerCloseIcon: 'order-filter-drawer__header-close-icon',

    gridRoot: 'order-filter-drawer__grid-root',

    inputOrderNumber: 'order-filter-input--order-number',
    inputCustomerPhone: 'order-filter-input--customer-phone',
    inputDeliveryPhone: 'order-filter-input--delivery-phone',
    sellerAutocompleteWrap: 'order-filter-input--seller-autocomplete-wrap',
    inputShippingListNo: 'order-filter-input--shipping-list-no',
    inputDPackage: 'order-filter-input--dpackage-no',
    inputTrackingCode: 'order-filter-input--tracking-code',
    inputBarcodes: 'order-filter-input--barcodes',

    selectPaymentMethod: 'order-filter-input--payment-method',
    formControlPaymentMethod: 'order-filter-input__form-control--payment-method',
    orderStatusAutocompleteWrap: 'order-filter-input--order-status-autocomplete-wrap',

    formControlCargoCompany: 'order-filter-input__form-control--cargo-company',
    selectCargoCompany: 'order-filter-input--cargo-company',

    dateRangerWrap: 'order-filter-input--date-ranger-wrap',

    clearButton: 'order-filter-input--button-clear',
    searchButton: 'order-filter-input--button-search',
} as const;

